import { render } from "./Home.vue?vue&type=template&id=4203efd6&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=4203efd6&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4203efd6"

export default script